import { XIIcon } from '@inmoment/the-kitchen';
import * as React from 'react';
import { FAQDropdownWrapper, QuestionWrapper } from './FAQDropdown_SC';

interface FAQDropdownObject {
  title: string;
  content: JSX.Element;
}
interface FAQDropdownProps {
  data: FAQDropdownObject[];
}

export const FAQDropdown = (props: FAQDropdownProps) => {
  const { data } = props;

  const [openId, setIsOpenId] = React.useState<number | undefined>();

  const handleSetId = (id: number) => {
    if (openId === id) {
      setIsOpenId(undefined);
    } else {
      setIsOpenId(id);
    }
  };
  const mappedData = data.map((question, i) => {
    const isOpen = openId === i;
    return (
      <>
        <QuestionWrapper isOpen={isOpen} onClick={() => handleSetId(i)}>
          <h4 style={{ color: isOpen ? 'white' : '', paddingLeft: 12 }}>{question.title}</h4>
          <XIIcon icon={isOpen ? 'single_arrow_up' : 'single_arrow_down'} contrast={isOpen ? 'high' : 'normal'} />
        </QuestionWrapper>
        {isOpen ? (
          <div>
            <br />

            {question.content}
          </div>
        ) : null}
        <hr />
      </>
    );
  });
  return <FAQDropdownWrapper>{mappedData}</FAQDropdownWrapper>;
};
